const buyItAgain = {
    getProductResults: function() {
        return fetch('/api/BuyAgain/GetBuyAgainSuggestions').then(response => response.json());
    },
    processResults: function(results) {
        var $producGrid = $('#product-grid');
        if (results && results.products) {
            results.products.forEach(function(result) {
                var $element = $producGrid.find('[data-productid="' + result.productClassId + '"]');

                if (smartPak.page.isMobile() && $element.length) {
                    buyItAgain.addBuyItAgainBadge($element.closest('.productListItem'));
                } else {
                    buyItAgain.addBuyItAgainBadge($element.closest('.product'));
                }
            });
        }
    },
    addBuyItAgainBadge: function($element) {
        var existingProductBadge = $element.find(
                '.product-recommendations-container, .sale-badge, .closeoutTag, .special-deal-badge'
            ),
            newItemBadge = $element.find('.new-product-badge');

        if (!existingProductBadge.length && !newItemBadge.length) {
            $element
                .addClass('bia-recommendation-container')
                .prepend('<div class="product-badge buy-it-again-badge">BUY IT AGAIN</div>');
        } else if (newItemBadge.length) {
            $element
                .addClass('bia-recommendation-container')
                .prepend('<div class="product-badge buy-it-again-badge">BUY IT AGAIN</div>');
            $(newItemBadge).remove();
        }
    }
};

export default buyItAgain;
